import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { InfoIcon } from "lucide-react"
import { CalculatorFormData } from "@/lib/types/calculator"

interface WorkScheduleSectionProps {
  form: CalculatorFormData;
  onFormChange: (field: string, value: string | boolean) => void;
}

export function WorkScheduleSection({
  form,
  onFormChange
}: WorkScheduleSectionProps) {
  return (
    <Card>
      <CardContent className="pt-6">
        <h3 className="text-lg font-medium mb-4">Work Schedule</h3>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="hoursPerDay" className="flex items-center">
              Hours per Day
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <InfoIcon className="h-4 w-4 ml-1 text-muted-foreground" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Standard working hours per day (used to calculate annual work hours and productive time)</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </Label>
            <Input
              id="hoursPerDay"
              type="number"
              step="0.5"
              min="1"
              max="24"
              value={form.hoursPerDay}
              onChange={(e) => onFormChange("hoursPerDay", e.target.value)}
              placeholder="e.g. 8"
            />
            <p className="text-xs text-muted-foreground">
              Annual work hours: {(260 * parseFloat(form.hoursPerDay || "8")).toLocaleString()} 
              ({form.hoursPerDay || "8"} hrs/day × 260 work days/year)
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
} 